import { useSetAtom } from 'jotai';
import { useCallback } from 'react';
import {
  openConfigurationProfileCreateModalAtom,
  selectedActionAtom,
  selectedConfigurationProfileIdAtom,
} from '../pages/configuration-profile-list-page/ConfigurationProfileListPage.atom';

export function useConfigurationProfileActions({
  handleToggleDeleteDialog,
  setDeletedId,
}: {
  readonly handleToggleDeleteDialog: () => void;
  readonly setDeletedId: (id: string) => void;
}) {
  const setOpenModal = useSetAtom(openConfigurationProfileCreateModalAtom);
  const setAction = useSetAtom(selectedActionAtom);
  const setSelectedConfigurationProfileId = useSetAtom(selectedConfigurationProfileIdAtom);

  const onDuplicateClick = useCallback(
    (configurationProfileId: string | undefined, name: string | undefined, description: string | undefined) => {
      setOpenModal((state) => !state);
      setAction('duplicate');
      setSelectedConfigurationProfileId({ id: configurationProfileId, name, description });
    },
    [setAction, setOpenModal, setSelectedConfigurationProfileId],
  );

  const onDeleteClick = useCallback(
    (id: string) => {
      setDeletedId(id);
      handleToggleDeleteDialog();
    },
    [handleToggleDeleteDialog, setDeletedId],
  );

  return {
    onDuplicateClick,
    onDeleteClick,
  };
}
